import { render, staticRenderFns } from "./uc-menu-sub.vue?vue&type=template&id=92c52a02&scoped=true&"
import script from "./uc-menu-sub.vue?vue&type=script&lang=ts&"
export * from "./uc-menu-sub.vue?vue&type=script&lang=ts&"
import style0 from "./uc-menu-sub.vue?vue&type=style&index=0&id=92c52a02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c52a02",
  null
  
)

export default component.exports